import React from 'react';
import '../css/VideoPlayer.css'; 


const VideoPlayer = ({videoLink}) => {
  return (
    <div className="video-container">
      <video controls class="video">
        <source src={videoLink} type="video/mp4" />
        Your browser does not support the video tag.
      </video>
    </div>
  );
};

export default VideoPlayer;
